module.exports = __webpack_public_path__ + "assets/img/report-data-bg-3.8df645e2.png";